import styled from 'styled-components';

export const UiBrowserSuggestion = styled.div`
    margin-top: 40px;
    @media (min-width: 1200px) {
        padding: 40px 208px
    }
`;